export default __webpack_public_path__ + "static/media/reports_user_permissions.e64d7b9f.png";